import React, { useState } from 'react';
import './FAQItem.css'; // Update or create this CSS file

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="faq-item">
      <div className="faq-question" onClick={handleToggle}>
        <span className="question-text">{question}</span>
        <span className={`arrow ${isOpen ? 'up' : 'down'}`}>&#9660;</span>
      </div>
      {isOpen && (
        <div className="faq-answer">
          <p className="answer-text">{answer}</p>
        </div>
      )}
    </div>
  );
};

export default FAQItem;
